import { API_BASE_URL } from "@kupikupi/brand";
import { useQuery } from "@tanstack/react-query";
import { getBaseConfig, getStorageConfig } from "../endpoints/base";
import { queryKeys } from "../query-keys";

export function useBaseConfig() {
  return useQuery({
    queryKey: queryKeys.baseConfig(),
    queryFn: () => getBaseConfig({ baseUrl: API_BASE_URL }),
    staleTime: 5 * 60 * 1000,
  });
}

/**
 * Warehouse storage policy (free period / retention / unit price) from
 * `GET /base/config`. Public config — no auth required.
 */
export function useStorageConfig() {
  return useQuery({
    queryKey: queryKeys.storageConfig(),
    queryFn: () => getStorageConfig({ baseUrl: API_BASE_URL }),
    staleTime: 5 * 60 * 1000,
  });
}
